<template>
    <!-- Breadcrumbs are not drawn here: report controllers send them to the
         top nav through TopNavHelper. -->
    <div class="flex w-full flex-col">
        <div class="mb-2 flex flex-wrap items-center gap-2 sm:gap-3">
            <div    v-if="$slots.icon"
                    class="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-blue-500 text-white">
                <slot name="icon"></slot>
            </div>

            <!-- ! prefixes override a global Bootstrap-style base sheet
                 (h1-h6 { font-size:1.5rem; font-weight:500; line-height; margin;
                 text-align:center }) that otherwise partially clobbers these
                 utilities. To be replaced by a proper heading refactor later. -->
            <h1 class="!my-0 p-0 !text-left !text-xl !font-bold !leading-tight text-gray-900 sm:!text-3xl">
                {{ title }}
            </h1>

            <!-- More about the report, on hover or focus. -->
            <info-tip v-if="info"
                      :text="info"
            ></info-tip>

            <div    v-if="$slots.actions"
                    class="ml-auto flex flex-wrap items-center justify-end gap-3">
                <slot name="actions"></slot>
            </div>
        </div>

        <p  v-if="description"
            class="m-0 text-left text-sm text-gray-600 sm:text-base">
            {{ description }}
        </p>
    </div>
</template>

<script>
import InfoTip from "@/components/elements/InfoTip.vue"

export default {
    name: "ReportPageHeader",
    components: {InfoTip},
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: null,
        },
        // Longer explanation shown from the info icon beside the title.
        info: {
            type: String,
            default: null,
        },
    },
}
</script>
